/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/barcode/BarcodeUseCase.yaml
import { FindAndPickScanningMode } from '../../ui_v2/barcode/FindAndPickScanningModeUseCase';
import { MultipleScanningMode } from '../../ui_v2/barcode/MultipleScanningModeUseCase';
import { SingleScanningMode } from '../../ui_v2/barcode/SingleScanningModeUseCase';
/** @internal */
export var BarcodeUseCase;
(function (BarcodeUseCase) {
    /** @internal */
    function From(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'SingleScanningMode':
                return new SingleScanningMode(source);
            case 'MultipleScanningMode':
                return new MultipleScanningMode(source);
            case 'FindAndPickScanningMode':
                return new FindAndPickScanningMode(source);
            default:
                throw `Unknown child class name: ${_type}`;
        }
    }
    BarcodeUseCase.From = From;
})(BarcodeUseCase || (BarcodeUseCase = {}));
//# sourceMappingURL=BarcodeUseCase.js.map